import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import { getMilestoneBudgetDashboard } from "../../api/casp/milestone";
import { withTranslation } from "react-i18next";

function ApexColumnBarChart({ projectId, t }) {
  const [milestoneData, setMilestoneData] = useState()

  useEffect(() => {
    fetchMilestoneList()
  }, [])

  /** Fetch milestone list from api */
  const fetchMilestoneList = async () => {
    try {
      const res = (await getMilestoneBudgetDashboard({ projectId })).data.data;
      if (res.length > 0) {
        const plannedCost = []
        const actualCost = []
        const milestoneName = []
        res.forEach(item => {
          plannedCost.push(item.budget?.plannedCost ?? 0)
          actualCost.push(item.budget?.actualCost ?? 0)
          milestoneName.push(item.name)
        })

        setMilestoneData({
          plannedCost: plannedCost,
          actualCost: actualCost,
          milestoneName: milestoneName
        })
      }
    } catch (error) {
      console.log(error);
    }
  };

  const data = {
    series: milestoneData ? [
      {
        name: t("Planned Cost"),
        data: milestoneData.plannedCost
      },
      {
        name: t("Actual Cost"),
        data: milestoneData.actualCost
      },
    ] : [],
    options: {
      chart: {
        type: "bar",
        height: 280,
      },
      noData: {
        text: t('No data found'),
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: 'black',
          fontSize: '16px',
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "60%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: milestoneData?.milestoneName,
        labels: {
          rotate: -90,
          rotateAlways: true,
          trim: true,
          hideOverlappingLabels: true,
          show: true,
        },
        tickPlacement: 'on',
      },
      yaxis: {
        title: {
          text: "SAR ",
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return "SAR " + val;
          },
        },
        x: {
          show: true
        },
      },
    },
  };

  return (
    <>
      <Chart
        options={data.options}
        series={data.series}
        type="bar"
        height={350}
      />
    </>
  );
}
export default withTranslation() (ApexColumnBarChart);